import { H4 } from '@ui-library/typography';
import React from 'react';
import Schedules, { ScheduleProps } from './schedules';
import ScheduleSelect, { ScheduleSelectProps, ScheduleTypes } from './scheduleTypes';

const ScheduleSettings: React.FC<ScheduleSelectProps & ScheduleProps> = ({
  scheduleType,
  setInvalid,
  value,
  onScheduleTypeChange,
  onRunSettingsChange,
}: ScheduleSelectProps & ScheduleProps) => (
  <>
    <ScheduleSelect scheduleType={scheduleType} onScheduleTypeChange={onScheduleTypeChange} />
    {scheduleType !== ScheduleTypes.Manual && <H4 className="m-t-md m-b-xs">Run Settings</H4>}
    <Schedules
      value={value}
      scheduleType={scheduleType}
      onRunSettingsChange={onRunSettingsChange}
      setInvalid={setInvalid}
    />
  </>
);
export default ScheduleSettings;
